import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    height: '100vh',
    overflow: 'auto',
    fontFamily: 'Roboto',
    '@media all and (max-width: 900px)': {
      height: '100vh',
      marginTop: 80
    }
  },
  mainContainer: {
    width: '100%',
    marginTop: '2%',
    marginLeft: '2%'
  },
  boxtitle: {
    display: 'flex',
    alignItems: ' center',
    color: '#2C3532',
    marginLeft: '5%',
    marginTop: '1.5rem'
  },
  title: {
    fontSize: '2em',
    letterSpacing: '0.04rem',
    '@media all and (max-width: 600px)': {
      fontSize: '1.5em'
    }
  },
  boxSubTitle: {
    width: '90%',
    display: 'flex',
    alignItems: 'center',
    color: '#4B4952',
    background: '#f9f9f9',
    boxShadow: '0px 1px 4px rgba(36, 55, 143, 0.2)',
    borderRadius: 10,
    paddingBottom: 10,
    paddingTop: 10,
    marginLeft: '5%',
    marginTop: '0.5rem',
    '@media all and (max-width: 600px)': {
      fontSize: '0.8em'
    }
  },
  boxSubTitleAlert: {
    width: '40%',
    display: 'flex',
    alignItems: 'center',
    color: '#4B4952',
    // background: '#f9f9f9',
    boxShadow: '0px 1px 4px rgba(36, 55, 143, 0.2)',
    borderRadius: 10,
    paddingBottom: 10,
    paddingTop: 10,
    marginLeft: '5%',
    marginTop: '1rem',
    '@media all and (max-width: 600px)': {
      fontSize: '0.8em'
    }
  },
  boxInput: {
    width: '90%',
    marginTop: '5%',
    marginLeft: '5%'
  },
  titleInput: {
    color: '#2C3532',
    fontSize: '1em',
    '@media all and (max-width: 600px)': {
      fontSize: '0.8em'
    },
    paddingBottom: 10
  },
  subtitle: {
    fontSize: '0.9rem',
    marginLeft: 8,
    fontWeight: 'bold'
  },
  linkButton: {
    border: 'none',
    cursor: 'pointer',
    fontWeight: 'bolder',
    textDecoration: 'underline',
    fontSize: '1em',
    backgroundColor: 'transparent',
    margin: 0,
    fontFamily: 'Roboto',
    color: '#00a78f'
  }
}))

export default useStyles
